import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Status from '@components/Status/index';

import { useGetLastRecordUpdate } from '@hooks/api/patient-record';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  lastUpdate: {
    id: 'recordSync.lastUpdate',
    defaultMessage: 'Last Account Update{separator} {lastUpdate}',
  },
  never: {
    id: 'recordSync.never',
    defaultMessage: 'Never',
  },
  loading: {
    id: 'recordSync.loading',
    defaultMessage: 'Loading...',
  },
});

const RecordSync: React.FC = () => {
  const { formatMessage } = useIntl();
  const [message, setMessage] = useState(formatMessage(messages.loading));
  const {
    state: { isClient },
  } = useSession();
  const {
    state: { patientView },
  } = useCuration();
  const skip = !(isClient || patientView);
  const { data, loading } = useGetLastRecordUpdate(skip);

  useEffect(() => {
    if (skip) {
      return;
    }
    const lastRecordUpdate = data?.getLastRecordUpdate;

    if (lastRecordUpdate === undefined) {
      setMessage(
        formatMessage(messages.lastUpdate, {
          separator: ':',
          lastUpdate: formatMessage(messages.loading),
        })
      );
    } else if (lastRecordUpdate === null) {
      setMessage(
        formatMessage(messages.lastUpdate, {
          separator: ':',
          lastUpdate: formatMessage(messages.never),
        })
      );
    } else {
      setMessage(
        formatMessage(messages.lastUpdate, {
          separator: ':',
          lastUpdate: dayjs(lastRecordUpdate).format('MMM DD/YY'),
        })
      );
    }
  }, [data?.getLastRecordUpdate, formatMessage, skip]);

  if (skip) {
    return null;
  }

  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <Status greyText variant={loading ? 'yellow' : 'green'} />
      <Typography
        data-testid="record-sync-text"
        variant="caption"
        fontSize={13}
      >
        {message}
      </Typography>
    </Stack>
  );
};

export default RecordSync;
